var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "pricing-container" },
    [
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("package-card-layout", {
            on: { selectedPackage: _vm.selectPackage }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { attrs: { gutter: 20 } },
        [
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "12px",
                  color: "#003333",
                  "font-weight": "bold",
                  "margin-bottom": "10px"
                }
              },
              [_vm._v("* all prices include GST.")]
            )
          ]),
          _vm._v(" "),
          _c("el-col", { attrs: { span: 24 } }, [
            _c(
              "span",
              {
                staticStyle: {
                  "font-size": "12px",
                  color: "#003333",
                  "font-weight": "bold",
                  "margin-bottom": "10px"
                }
              },
              [_vm._v("* 12 month subscription term.")]
            )
          ])
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37fd544c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37fd544c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/register/uConnectRegistration/selectPackage/uConnectSelectPlanDetailsStep.vue
// module id = null
// module chunks = 